import React, { useState, useRef ,useEffect} from 'react';
import { ReactTabulator } from 'react-tabulator';
import { API_BASE_URL } from './config';
// Import at least one Tabulator theme + the base styles
import 'react-tabulator/lib/styles.css';

import 'react-tabulator/css/tabulator_bootstrap5.css';
import 'react-tabulator/css/tabulator_midnight.min.css';




function TabulatorExample() {
  const [apiSwitch, setApiSwitch] = useState(true);

  const [endpoint, setEndpoint]=useState({false:`${API_BASE_URL}/hourlyweather`,true:`${API_BASE_URL}/dailyweather`})
  const [endpointurl, setEndpointurl]=useState(`${API_BASE_URL}/dailyweather`)
  const [isProcessing, setIsProcessing] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const checkHiddenCharFormatter = function(cell, formatterParams, onRendered) {
    const value = cell.getValue();
    // console.log("value is:", value);
    
    // Skip if value is null or undefined
    if (value === null || value === undefined) {
      return "";
    }
    
    const stringValue = String(value);
    
    // Check for hidden characters
    if (stringValue.includes('\u200B')) {

      // console.log("zero-width space")
      cell.getElement().style.backgroundColor = "#ffb703";
    } else if (stringValue.includes('\u200C')) {
      cell.getElement().style.backgroundColor = "#8ecae6";
    } else if (stringValue.includes('\uFEFF')) {
      cell.getElement().style.backgroundColor = "#fb8500";
    }
    
    // Clean the display value
    return stringValue.replace(/[\u200B\u200C\u200D\u2060\uFEFF]/g, '');
  };

  // State holds the data for the table.
  // Each item is an object representing one row.
  useEffect(() => {
    // Fetch initial data from the API when the component mounts
    setEndpointurl(endpoint[apiSwitch])
    console.log("endpoint is:", endpointurl)
  }, [apiSwitch]);



  
  const [tableData, setTableData] = useState([
    {id:0, address: '123 Alice drive 30318', name: 'Smith', date: '2025-04-12' },
    {id:1, address: '123 Bob Road 40318', name: 'Baker', date: '2025-04-13' },
  ]);
  // Define columns. Each column has a "field" that matches keys in your data,
  // a "title" for the column header, and an optional editor if you want inline editing.
  const [columns,setColumns]= useState( [
    { title: 'Address', field: 'address', editor: 'input' ,frozen:true,formatter:checkHiddenCharFormatter},
    { title: 'Name', field: 'name', editor: 'input',frozen:true},
    { title: 'Date', field: 'date', editor: 'input' ,frozen:true// Tabulator's built-in date editor
        },
  ]);


  // A ref to the Tabulator table instance (optional, if you want direct access to Tabulator methods).
  const tableRef = useRef(null);

  const createEmptyRow = () => {
    const newRow = {};
    columns.forEach((col) => {
      newRow[col.field] = ''; 
      // or some default value, e.g. 0 or null:
      // newRow[col.field] = col.field === 'age' ? 0 : '';
    });
    return newRow;
  };
  const handleToggle = () => {
    setIsProcessing(true);

    setApiSwitch((prevData) =>!prevData);
    setIsProcessing(false);

  };

  // Add a blank row to the end of the table
  const handleAddRow = () => {
    const newRow = createEmptyRow();
    setTableData((prevData) => [...prevData, newRow]);
  };

  


  const globalCellFormatter = (cell) => {
    const value = cell.getValue();
    const stringValue = String(value);
    // Check for hidden characters
    if (stringValue.includes('\u200B')) {  // Zero-width space
      cell.getElement().style.backgroundColor = "#ffb703";
    } else if (stringValue.includes('\u200C')) {  // Zero-width non-joiner
      cell.getElement().style.backgroundColor = "#8ecae6";
    } else if (stringValue.includes('\uFEFF')) {  // Byte order mark
      cell.getElement().style.backgroundColor = "#fb8500";
    }
    
    // Clean the display value
    return stringValue.replace(/[\u200B\u200C\u200D\u2060\uFEFF]/g, '');
  };



  const handleRef = (table) => {
    tableRef.current = table;
  };
  

  const FetchWeather = async (newData) => {

    
    try {
      // 2) Fetch new data from your API
      //    (Adjust the URL and request details as needed)
      console.log("endpoint is:", endpointurl)
      const token = localStorage.getItem('access_token');

      const response = await fetch(endpointurl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        // Maybe send the main table data to the server so it knows what to return
        body: JSON.stringify({ mainTableData: newData }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const jsonData = await response.json();

      let columnsExtra = jsonData.columns.map((col) => {
        // console.log("col is:", col);
        
        return { ...col, formatter: checkHiddenCharFormatter };
        
      });
      
      setColumns(columnsExtra);
      setTableData(JSON.parse(jsonData.special));
      // setColoringInfoArray(jsonData.coloring)
      // console.log("after apiTable built, instance available ref is:", tableRef);
      // colorSpecialCells();

      // if (tableRef.current) {
      //   tableRef.current.current.redraw();
      // }

    } catch (error) {
      console.error('API call error:', error);
    }
  };


  return (
    // <div style={{ margin: '1rem' , width: '1000px', overflowX: 'auto' }}>
    <div style={{ margin: '1rem'}} >
      <h2>Tabulator in React</h2>
      <div style={{ margin: '1rem' , width: windowWidth, overflow: 'hidden'}} >
      <ReactTabulator
        // ref={tableRef}
        onRef={handleRef}
        data={tableData}
        columns={columns}
        // "fitData" will size columns to their content;
        // layout="fitDataTable"
        // you could also use "fitDataFill", "fitColumns", etc. 
        layout="fitData"
        options={{
          clipboard: true,
          // reactiveData: false,
          index: 'id', // Unique ID for each row
          cellFormatter: globalCellFormatter,
          
          // When user pastes, replace table data entirely with the new content
          clipboardPasteAction: 'update',

          clipboardPasteMode: 'formatted', // parse as a simple table of rows/columns
        }}
        // Tabulator events can be subscribed to via the "events" prop in react-tabulator.
        // Example: we keep React state in sync when data is edited in the table:
        events={{
          // dataEdited: handleMainTableEdited,
          dataChanged: (newData) => {
            // "newData" is the table’s current data after the edits.
            FetchWeather([...newData]);
            
          },
          

        }}
      />
      </div>

      <button onClick={handleAddRow} style={{ marginTop: '1rem' }}>
        Add New Row
      </button>
      <button onClick={handleToggle} disabled={isProcessing}>
        {apiSwitch ? 'Daily' : 'Hourly'}
      </button>

    </div>
  );
}


export default TabulatorExample ; 